(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initCartDrawer();
    initProductForm();
    initProductThumbs();
    initStickyAtc();
  });

  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var isOpen = !nav.hasAttribute('hidden');
      if (isOpen) {
        nav.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        nav.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.removeAttribute('hidden');
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.setAttribute('hidden', '');
  }

  function initProductForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Let normal "Buy it now" checkout submissions go straight through.
        if (e.submitter && e.submitter.name === 'checkout') return;

        var useDrawer = document.body && window.__cartType !== 'page';
        if (!useDrawer) return;

        e.preventDefault();
        var formData = new FormData(form);

        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function () { return refreshCartDrawer(); })
          .then(function () { openCartDrawer(); })
          .catch(function () { form.submit(); });
      });
    });
  }

  function refreshCartDrawer() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var body = document.querySelector('[data-cart-drawer-body]');
        var countEl = document.querySelector('[data-cart-icon] .site-header__cart-count');
        var subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
        if (countEl) countEl.textContent = cart.item_count;
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        if (!body) return;
        if (cart.item_count === 0) {
          body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
          return;
        }
        body.innerHTML = cart.items.map(function (item) {
          return (
            '<div class="cart-drawer__item">' +
              '<img src="' + item.image + '" alt="" width="80" height="80">' +
              '<div class="cart-drawer__item-info">' +
                '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
                '<p class="cart-drawer__item-meta">Qty ' + item.quantity + ' · ' + formatMoney(item.final_line_price) + '</p>' +
              '</div>' +
            '</div>'
          );
        }).join('');
      });
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
        minimumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return 'Rs. ' + amount.toFixed(2);
    }
  }

  function initProductThumbs() {
    var thumbs = document.querySelectorAll('[data-product-thumb]');
    thumbs.forEach(function (thumb) {
      var targetId = thumb.getAttribute('data-target') || 'ProductMainImage';
      var mainImg = document.getElementById(targetId);
      if (!mainImg) return;
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.getAttribute('data-full');
      });
    });
  }

  function initStickyAtc() {
    document.querySelectorAll('[data-sticky-atc]').forEach(function (sticky) {
      var section = sticky.previousElementSibling;
      var trigger = section && section.querySelector('.product-form__price');
      if (!trigger) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.classList.remove('is-visible');
          } else if (entry.boundingClientRect.top < 0) {
            sticky.classList.add('is-visible');
          } else {
            sticky.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });

      observer.observe(trigger);
      sticky.removeAttribute('hidden');
var footer = document.querySelector('.site-footer');

if (footer) {
  var footerObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      sticky.style.display = entry.isIntersecting ? 'none' : '';
    });
  }, { threshold: 0 });

  footerObserver.observe(footer);
}
    });
  }
})();
